import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import Icon from '../../_shared/components/Icon';

export const CheckIcon = styled(Icon).attrs(({ theme }) => ({
  icon: 'TR5-Toggle_check',
  color: theme.COLORS.BASE
}))`
  height: 22px;
  width: 22px;
  margin: -1px -4px -1px 2px;
`;

export const StyledTooltip = styled(ReactTooltip)`
  padding: 6px 10px !important;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_30} !important;
  color: ${({ theme }) => theme.COLORS.BASE} !important;
  font-size: 14px !important;
  white-space: nowrap !important;
  opacity: 1 !important;
`;

export default {};
